var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMyLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_3413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.25C9.50571 14.25 10.625 13.1307 10.625 11.75C10.625 10.3693 9.50571 9.25 8.125 9.25C6.74429 9.25 5.625 10.3693 5.625 11.75C5.625 13.1307 6.74429 14.25 8.125 14.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17109 16.75C4.52567 16.0014 5.08548 15.3688 5.78542 14.9259C6.48536 14.4829 7.29667 14.2478 8.125 14.2478C8.95333 14.2478 9.76464 14.4829 10.4646 14.9259C11.1645 15.3688 11.7243 16.0014 12.0789 16.75H16.875C17.0408 16.75 17.1997 16.6842 17.3169 16.5669C17.4342 16.4497 17.5 16.2908 17.5 16.125V4.875C17.5 4.70924 17.4342 4.55027 17.3169 4.43306C17.1997 4.31585 17.0408 4.25 16.875 4.25H3.125C2.95924 4.25 2.80027 4.31585 2.68306 4.43306C2.56585 4.55027 2.5 4.70924 2.5 4.875V16.125C2.5 16.2908 2.56585 16.4497 2.68306 16.5669C2.80027 16.6842 2.95924 16.75 3.125 16.75H4.17109Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14.25H15V6.75H5V8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_3413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMyLab);
export default __webpack_public_path__ + "static/media/nav-myLab.a21de10b8fd03166ada5d1575eb374c8.svg";
export { ForwardRef as ReactComponent };